// extracted by mini-css-extract-plugin
module.exports = {"location":"location___OKOux"};